import { openBlock as r, createElementBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return r(), o("svg", n, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M9.29 15.88 13.17 12 9.29 8.12a.996.996 0 1 1 1.41-1.41l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3a.996.996 0 0 1-1.41 0c-.38-.39-.39-1.03 0-1.42"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
